import {Record} from 'immutable';
import _ from 'lodash';

export default class User extends Record({
    id: null,
    username: null,
    profiles: null,
    permissions: null,
}) {

    /**
     * Retorna true se usuário tem determinado profile.
     *
     * @param {string} profile
     * @returns {boolean}
     */
    hasProfile(profile) {
        if (this.profiles === null || this.profiles.length === 0)
            return false;

        return !!_.find(this.profiles, (p) => p === profile);
    }

    /**
     * Retorna true se usuário tem determinada permissão.
     *
     * @param {string} permission
     * @returns {boolean}
     */
    hasPermission(permission) {
        if (this.permissions === null || this.permissions.length === 0)
            return false;

        return !!_.find(this.permissions, (p) => p === permission);
    }
}


// WEBPACK FOOTER //
// src/domain/User.js